<template>
  <div class="mt-3">
    <h5>Sorry, no items matching your request were found.</h5>
    <hr />

    <div v-html="vehicleRequestForm"></div>

    <hr />

    <div id="suggest-vehicles" v-if="this.suggestedVehicles">

      <h5 class="text-center">Other Vehicles You May Be Interested In</h5>

      <div class="row mb-4">

        <div class="col pt-1">

          <div class="card-deck">

            <div class="card d-none d-md-block" v-for="(car, carIndex) in this.suggestedVehicles" :key="car.stock_num">
              <div class="card-title"></div>

                <div class="card-body" :data-count="carIndex">

                  <h6 class="mb-2">
                    <a :href='"/vehicles/vehicle_details/continental/" + car.stock_num + "/" + car.stock_type + "/" + car.year + "/" + car.make + "/" + car.model + "?stock_num=" + car.stock_num'>{{ car.year }} {{ car.make }} {{ car.model }}</a><br/></h6>

                  <p v-if="car.on_special === 'y'">SALE PRICE: <span class="sale_price">{{ addComma(car.base_price) }} </span></p>

                  <div v-else-if="car.book_value > 0">

                    <p class="mb-1 small">NADA Retail: ${{ addComma(car.book_value) }}</p>

                    <p>SALE PRICE: <span class="sale_price">${{ addComma(car.base_price) }}</span></p>

                  </div>

                  <p class="mb-2" v-else>
                    <strong>LIST PRICE:&nbsp;
                    <span v-if="car.list > 249">${{ addComma(car.list) }}</span>
                    <span v-else-if="car.list < 200 && car.final_price > 249">${{ addComma(car.final_price) }}</span>
                    <span v-else>N/A</span>
                    </strong>
                  </p>

                  <a :href='"/vehicles/vehicle_details/continental/" + car.stock_num + "/" + car.stock_type + "/" + car.year + "/" + car.make + "/" + car.model + "?stock_num=" + car.stock_num'>

                    <img
                      v-if="car.actual_photos_single"
                      :src="car.actual_photos_single"
                      :alt='car.year + " " + car.make + " " + car.model + " " + car.stock_num'
                      width="640" height="480"
                      class="img-fluid mx-auto d-block"
                    />

                    <img
                      v-else-if="car.best_stock_photo"
                      :src="car.best_stock_photo"
                      :alt='car.year + " " + car.make + " " + car.model + " " + car.stock_num'
                      width="640" height="480"
                      class="img-fluid mx-auto d-block"
                    />

                    <img
                      v-else
                      src="/images/site/noimage.gif"
                      :alt='car.year + " " + car.make + " " + car.model + " " + car.stock_num'
                      width="640" height="480"
                      class="img-fluid mx-auto d-block"
                    />

                  </a>

                </div>

                <div class="col-12">

                  <a class="btn btn-sm btn-outline-primary btn-block mb-3"  :href='"/vehicles/vehicle_details/continental/" + car.stock_num + "/" + car.stock_type + "/" + car.year + "/" + car.make + "/" + car.model + "?stock_num=" + car.stock_num' :title='"See more details on this " + car.stock_type + " " + car.year + " " + car.make + " " + car.model + "(Stock# " + car.stock_num + ")"'>vehicle details</a>

                  <ul class="small list-unstyled">

                    <li v-if="car.custom_message">{{ car.custom_message }}</li>

                    <li><strong>Miles: </strong>{{ addComma(car.mileage) }}</li>

                    <li v-if="car.displ_liters"><strong>Engine:</strong> {{ car.displ_liters }} liter</li>

                    <li v-if="car.drive"><strong>Drive:</strong> {{ car.drive }}</li>

                    <li v-if="car.color"><strong>Color:</strong> {{ car.color }}</li>

                    <li><strong>STK#:</strong> <span v-if="car.stock_num">{{ car.stock_num }}</span><span v-else>N/A</span></li>

                    <li><strong>Vin:</strong> <span v-if="car.vin">{{ car.vin }}</span><span v-else>N/A</span></li>

                    <li><strong>Status:</strong> {{ car.status }}</li>

                  </ul>

                </div>

              </div>

            </div>

          </div>

      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      vehicleRequestForm: '',
      suggestedVehicles: []
    }
  },
  computed: {
    ...mapState(['cars', 'carsFiltered', 'viewFormat'])
  },
  watch: {
    '$route.query': function (to, from) {
      // console.log('$route.query triggered by watch (from): ', from)
      // console.log('$route.query triggered by watch (to): ', to)
      this.suggestVehicles()
    }
  },
  created () {
    var url = '//continentalautogroup.com/vehicles/form_vehicle_request'
    if (window.location.hostname !== 'continentalautogroup.com') {
      url = '//dev.continentalautogroup.com/vehicles/form_vehicle_request'
    }

    this.suggestVehicles()

    axios.get(url)
      .then(response => {
        // JSON responses are automatically parsed.
        // this.posts = response.data
        this.vehicleRequestForm = response.data
      })
      .then(() => {
        window.Cag.utils.validateForms()
      })
      .catch(e => {
        console.log(e)
      })
  },
  methods: {
    suggestVehicles () {
      this.suggestedVehicles = []
      if (typeof (this.carsFiltered) === 'undefined' || this.carsFiltered === '') {
        var totalVehicles = this.cars.length

        // empty array for storing our matched vehicles
        var matchedVehicles = []
        var stockNumsAdded = []
        var numVehiclesToShow = 3
        var randomNum = 0

        for (var i = 0; i < totalVehicles; i++) {
          var car = this.cars[i]
          var keywords = car.keywords

          var matched = this.filterFunnel(keywords)

          if (matched === true) {
            matchedVehicles.push(car)
          }
        }
        var numMatches = matchedVehicles.length
        // console.log('Number of Matches: ', numMatches)

        if (numMatches > 0) {
          if (numMatches < numVehiclesToShow) {
            this.suggestedVehicles = matchedVehicles
          } else {
            // grab random matched vehicles
            for (i = 0; i < numVehiclesToShow; i++) {
              randomNum = this.getRandomInt(1, numMatches)

              var stockNum = matchedVehicles[randomNum].stock_num

              // prevent same random number from showing; needs to be unique
              if (!stockNumsAdded.includes(stockNum)) {
                this.suggestedVehicles.push(matchedVehicles[randomNum])
                stockNumsAdded.push(matchedVehicles[randomNum].stock_num)
              } else {
                // duplicate vehicle encountered; need to loop more one additional time
                i--
              }
            }
          }
        }

        if (this.suggestVehicles.length < numVehiclesToShow) {
          // not enough matched vehicles; need to add some randoms
          for (i = 0; i < (numVehiclesToShow - numMatches); i++) {
            randomNum = this.getRandomInt(1, totalVehicles)
            var unMatchedRandomVehicle = this.cars[randomNum]
            // prevent same random number from showing; needs to be unique
            if (!stockNumsAdded.includes(unMatchedRandomVehicle.stock_num)) {
              this.suggestedVehicles.push(unMatchedRandomVehicle)
              stockNumsAdded.push(unMatchedRandomVehicle.stock_num)
            } else {
              // duplicate vehicle encountered; need to loop more one additional time
              i--
            }
          }
        }
        // console.log(this.suggestedVehicles)
      }
    },
    filterFunnel (keywords) {
      var query = this.$route.query

      // loop through each keyword from keywordArray
      for (var queryKey in query) {
        // assign search item
        var search = query[queryKey]
        var matched = false

        if (typeof (search) === 'undefined') {
          continue
        }

        if (typeof (search) === 'string') {
          // console.log('STRING', search)
          search = search.toLowerCase()
          for (var carKey in keywords) {
            // assign keyword to carVal
            var carVal = keywords[carKey]
            if (carVal === '' || !carVal) {
              continue
            }
            carVal = carVal.toString()
            carVal = carVal.toLowerCase()

            if (carVal.indexOf(search) !== -1) {
              return true
            }
          }
        }

        if (typeof (search) === 'object') {
          // console.log('OBJECT', search)
          for (var searchVal in search) {
            var keyword = search[searchVal]
            if (typeof (keyword) === 'string') {
              keyword = keyword.toLowerCase()
            }

            for (const carKey in keywords) {
              // check if keyword field is empty or null
              if (!keywords[carKey].length) {
                continue
              }
              // assign keyword to carVal
              var carKeyword = keywords[carKey].toString()
              carKeyword = carKeyword.toLowerCase()
              if (carKeyword.indexOf(keyword) !== -1) {
                return true
              }
            }
          }
        }
      }
      return matched
    },
    getRandomInt (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min) + min) // The maximum is exclusive and the minimum is inclusive
    },
    addComma: function (value) {
      var valNum = Number(value)
      return parseInt(valNum).toLocaleString()
    }
  }
}
</script>
<style>

</style>
